/**
 * Event template constants
 */

// Maximum number of reminders allowed per event
export const MAX_REMINDERS = 3;
